import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useURLSync = (initialState) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [state, setState] = useState(() => {
    const params = {};
    Object.keys(initialState).forEach((key) => {
      params[key] = searchParams.get(key) || initialState[key];
    });
    return params;
  });

  useEffect(() => {
    const params = new URLSearchParams();
    Object.entries(state).forEach(([key, value]) => {
      if (value && value !== initialState[key]) {
        params.set(key, value);
      }
    });
    setSearchParams(params, { replace: true });
  }, [state, setSearchParams]);

  return [state, setState];
};
